module.exports = __webpack_public_path__ + "img/information-outline.7e774b31.svg";